import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './info-bubble.styl'

export default class InfoBubble extends Component {
  static propTypes = {
    onClick: PropTypes.func
  }

  render() {
    const { onClick } = this.props

    return (
      <button type='button' onClick={onClick} className={styles.btn}>i</button>
    )
  }
}
